<template>
  <transition name="modal-fade">
    <v-dialog :value="active" width="80vh" persistent>
      <v-card class="logWrap">
        <v-card-title primary-title>
          <h3>Recuperar contraseña</h3>
        </v-card-title>
        <v-card-text>
          <p>
            Se enviará un email al correo proporcionado para proceder al cambio
            de contraseña.
          </p>
          <v-text-field
            filled
            rounded
            dense
            append-icon="person"
            name="login"
            label="Correo electrónico"
            type="text"
            v-model="email"
            :rules="[rules.required, rules.validateEmail]"
            persistent-hint
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirm('confirmar')"
            class="white--text logWrap"
            color="#004283"
          >
            Confirmar
          </v-btn>
          <v-btn
            @click="confirm('cerrar')"
            class="white--text logWrap"
            color="#004283"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        required: value => !!value || "Campo requerido.",
        validateEmail: value =>
          value.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) != null || "Email inválido"
      },
      email: ""
    };
  },
  methods: {
    confirm(action) {
      if (action == "confirmar") {
        if (this.email == undefined || /^\s*$/.test(this.email)) {
          this.$emit("closeFP", "Campo vacío", null);
        } else if (
          this.email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) == null
        ) {
          this.$emit("closeFP", "Correo inválido", null);
        } else{
          this.$emit("closeFP", "confirmar", this.email);
        }
      } else {
        this.$emit("closeFP", action, null);
      }
    }
  }
};
</script>

<style scoped>
.logWrap {
  border-radius: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalForgetPass.vue